export const AUTH_ROUTES = {
  LOGIN: "login",
  REGISTER: "register",
  REGISTER_VERIFY: "register/verify",
  FORGOT_PASSWORD: "forgot-password",
  FORGOT_PASSWORD_VERIFY: "forgot-password/verify",
  FORGOT_PASSWORD_NEW: "forgot-password/new",
  FORGOT_PASSWORD_DONE: "forgot-password/done",
  INVITATION_ACCEPT: "invitations/accept",
};

export const AUTH_API_ENDPOINTS = {
  LOGIN: "/auth/login",
  REFRESH: "/auth/refresh",
  GET_ME: "/auth/me",
  LOGOUT: "/auth/logout",
  FORGOT_PASSWORD: "/auth/forgot-password",
  VERIFY_RESET_CODE: "/auth/forgot-password/verify",
  RESET_PASSWORD: "/auth/reset-password",
  CHANGE_PASSWORD: "/auth/change-password",
  INVITATION_VERIFY: "/auth/invitations/verify",
  INVITATION_ACCEPT: "/auth/invitations/accept",
};
